const title = process.env.VUE_APP_TITLE

export default {
  install(Vue) {
    Vue.prototype.$app = { title }
  }
}
